import React, { useEffect, useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./MobileUserHeader.css";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import MobileSideBarMenu from "./MobileSideBarMenu/MobileSideBarMenu.js";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

const MobileUserHeader = () => {
  const { authUser, token, theme, toggleTheme } = useContext(AuthContext);

  const [SideBarMenuShow, setSideBarMenuShow] = useState(false);

  const handleShow = () => {
    setSideBarMenuShow(!SideBarMenuShow);
  };

  const supportDropdownRef = useRef(null);
  const [isSupportActive, setIsSupportActive] = useState(false);

  const [supportData, setSupportData] = useState([]);

  useEffect(() => {
    axios
      .get(`https://api.wlffinance.org/api/admin/site/setting/social/support/view`)
      .then((res) => setSupportData(res?.data?.data))
      .catch((err) => console.log(err));
  }, []);

  const handleSupportDropdown = (e) => {
    e.stopPropagation();
    setIsSupportActive((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        supportDropdownRef.current &&
        !supportDropdownRef.current.contains(event.target)
      ) {
        setIsSupportActive(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);




  // notification 


  const [userMessageUnseenCount, setUserMessageUnseenCount] = useState(0)


  useEffect(() => {
    axios
      .get(`https://chat-api.wlffinance.org/api/user/chat/unseen/message/${authUser?._id}`)
      .then((res) => setUserMessageUnseenCount(res?.data?.count))
      .catch((err) => console.log(err));
  }, [authUser]);

  return (
    <>
      <div className="user-mobile-header-section">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="user-mobile-header-logo">
              <div onClick={handleShow}>
                <i className="fa-solid fa-user"></i>
              </div>
            </div>
            <div className="searchBarMain">
              <i className="fa-solid fa-magnifying-glass "></i>
              <input
                type="text"
                name="header-search"
                id="searchBarInput"
                placeholder="Search"
              />
            </div>
            <div className="user-mobile-header-icon">
              <div className="support-dropdown-menu chat-notifaction">

                <a
                  className="position-relative text-decoration-none"
                  href={`https://live-chat.wlffinance.org/authorized/${authUser?._id}`}
                >
                  <i className="fa-solid fa-headset"></i>
                  {userMessageUnseenCount > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {userMessageUnseenCount > 99 ? "99+" : userMessageUnseenCount}
                    </span>
                  )}
                </a>

                {/* <a className="" href={`https://live-chat.wlffinance.org/authorized/${authUser?._id}`}>
                  <i className="fa-solid fa-headset"></i>
                  <span>1</span>
                </a> */}
                <nav
                  ref={supportDropdownRef}
                  className={`support-dropdown-menu-item ${isSupportActive ? "active" : ""
                    }`}
                >
                  <ul>
                    <li>
                      <a
                        href={supportData?.telegram_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleSupportDropdown}
                      >
                        {supportData?.telegram_name}
                      </a>
                    </li>
                    <li>
                      <a
                        href={`mailto:${supportData?.email}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleSupportDropdown}
                      >
                        Email
                      </a>
                    </li>
                    <li>
                      <a
                        href={`https://live-chat.wlffinance.org/authorized?token=${token}`}
                        rel="noopener noreferrer"
                      >
                        Live Chat
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

              <Link to="/user/announcement" className="announcement-link">
                <i className="fa-solid fa-bell"></i>
              </Link>
              <div className="dark-light-mode-btn-area">
                <button onClick={toggleTheme}>
                  {theme === "dark" ? (
                    <>
                      <FontAwesomeIcon icon={faSun} className="theme-icon" />
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faMoon} className="theme-icon" />
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {SideBarMenuShow && <>
        <div >
          <MobileSideBarMenu
            handleShow={handleShow}
            authUser={authUser}
          ></MobileSideBarMenu>
        </div>
      </>}

    </>
  );
};

export default MobileUserHeader;
